import ews_resource from './ews_resource';
import ews_folder from './ews_folder';
import ews_calendar from './ews_calendar';

import db_main from './db_main';
import db_resource from './db_resource';
import db_folder from './db_folder';
import db_calendar from './db_calendar';

import db_resourceReserve from './db_resourceReserve';

export default {
    db_main,
    db_resource,
    db_folder,
    db_calendar,

    db_resourceReserve,
        
    ews_resource,
    ews_folder,
    ews_calendar,
}